import { InitialNotificationsState } from 'interfaces/notifications.interface';
import * as NotificationsTypes from './notifications.types';

export default function notificationsReducer(
  state: InitialNotificationsState,
  action: any
) {
  const { type, payload } = action;

  switch (type) {
    case NotificationsTypes.SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: state.notifications.sort((a, b) =>
          a.createdAt > b.createdAt ? -1 : 1
        ),
      };

    case NotificationsTypes.MARK_AS_READED_NOTIFICATION:
      const notificationsCopy = [...state.notifications];
      const indexNotification = notificationsCopy.findIndex(
        (notification) => notification.id === payload.id
      );
      notificationsCopy[indexNotification].read = payload.readed;
      return {
        ...state,
        notifications: notificationsCopy.sort((a, b) =>
          a.createdAt > b.createdAt ? -1 : 1
        ),
      };

    case NotificationsTypes.SET_NOTIFICATIONS_TYPES:
      return {
        ...state,
        notificationsTypes: payload,
      };

    default:
      return state;
  }
}
